"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
//
// assets
//
const noTrackingPages_png_1 = __importDefault(require("assets/images/dashboard/noTrackingPages.png"));
const trackingCopy_1 = require("copy/trackingCopy");
//
// components
//
const TrackingPageCard_1 = __importDefault(require("components/Dashboard/TrackingPageManager/TrackingPageCard"));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
//
// styles
//
const StyledListContainer_1 = require("components/Dashboard/TrackingPageManager/StyledListContainer");
const StyledErrorText_1 = require("components/Dashboard/StyledErrorText");
const StyledGraphic_1 = require("components/Dashboard/StyledGraphic");
const StyledGreyText_1 = require("components/Dashboard/StyledGreyText");
const StyledHeader_1 = require("components/Dashboard/StyledHeader");
const StyledMediumText_1 = require("components/Dashboard/StyledMediumText");
const StyledMessageContainer_1 = require("components/Dashboard/StyledMessageContainer");
const AllPages = () => {
    const { activeTrackingPages: trackingPages, error, loading, onEditPage, onArchivePage, onDeletePage, onLaunchEditor } = (0, react_router_dom_1.useOutletContext)();
    function displayError(apiError) {
        if (apiError.message.includes('ECONNREFUSED') ||
            apiError.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, trackingCopy_1.trackingCopy.fetchError));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, apiError.message));
    }
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, trackingCopy_1.trackingCopy.loading)));
    }
    function renderNoTrackingPages() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, { height: '370px' },
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { src: noTrackingPages_png_1.default }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, trackingCopy_1.trackingCopy.noTrackingPagesHeader),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-pages', role: 'paragraph' }, trackingCopy_1.trackingCopy.noTrackingPagesParagraph)));
    }
    function renderPages() {
        return (react_1.default.createElement(StyledListContainer_1.StyledListContainer, null, trackingPages.map((item) => (react_1.default.createElement(TrackingPageCard_1.default, { active: true, created: item.insertedAt, key: item.id, onArchive: () => onArchivePage(item), onDelete: () => onDeletePage(item), onEdit: () => onEditPage(item), onLaunchEditor: () => onLaunchEditor(item), title: item.name, updated: item.updatedAt, url: [item.hostedDomain.token, item.slug].join('/') })))));
    }
    if (error) {
        return react_1.default.createElement("div", null, displayError(error));
    }
    if (loading) {
        return renderLoading();
    }
    if (!trackingPages || trackingPages.length === 0) {
        return renderNoTrackingPages();
    }
    return renderPages();
};
exports.default = AllPages;
